"use strict";
function Phone(phone) {
    return {
        raw: phone,
        get unmask() {
            if (!phone)
                return "";
            return (phone.match(/\d/g) || ['']).join('');
        },
        get mask() {
            if (!phone)
                return "";
            const cleanedPhone = phone.replace(/\D/g, '');
            if (cleanedPhone.length === 10)
                return cleanedPhone.replace(/(\d{2})(\d{4})(\d{4})/g, '$1 $2-$3');
            return cleanedPhone.replace(/(\d{2})(\d{5})(\d{4})/g, '$1 $2-$3');
        },
        get censor() {
            if (!phone)
                return "";
            return phone.replace(/(\d{2})\s?\S{7,8}(\d{2}$)/g, '($1) ****-**$2');
        },
    };
}
window.Phone = Phone;
//# sourceMappingURL=index.js.map